<template>
  <div>

    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="" prop="companyCode">
        <el-input size="mini" clearable v-model="formInline.t.interfaceName" placeholder="请输入接口名称">
        </el-input>
      </el-form-item>

      <el-form-item prop="startTime">
        <el-date-picker type="datetime" size="mini"
                        v-model="formInline.t.startTime"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="开始日期" style="width: 175px"></el-date-picker>
        <span>至</span>
        <el-date-picker type="datetime" size="mini"
                        v-model="formInline.t.endTime"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="结束日期" style="width: 175px"></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
        <el-button size="mini" type="primary" :loading='loading' icon="el-icon-search" @click="search">查询</el-button>

        <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd()"
                   v-if="checkPermission(['bee:ict:cecInterfaceName:insert'])">添加
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
              @selection-change="selectChange"
              :data="userData"
              highlight-current-row
              v-loading="loading"
              border
              element-loading-text="拼命加载中"
              style="width: 100%;">


      <af-table-column prop="interfaceName" label="接口名称">
      </af-table-column>
      <af-table-column prop="interfaceExplain" label="接口描述">
      </af-table-column>
      <af-table-column prop="createTime" label="创建时间">
      </af-table-column>

      <af-table-column label="操作">
        <template slot-scope="scope">

          <template v-if="checkPermission(['bee:ict:cecInterfaceName:update'])">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>

          <template v-if="checkPermission(['bee:ict:cecInterfaceName:deleteInterfaceByID'])">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </template>
      </af-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination :child-msg="pageParam" @callFather="callFather"></Pagination>

    <!-- 添加界面 -->
    <AddPage
      :form-visible="addFormVisible"
      :searchData="searchData"
      @closeDialog="closeDialog"
      @afterAdd="afterAdd"
    ></AddPage>

    <!--修改-->
    <UpdatePage
      :form-visible="updateFormVisible"
      :searchData="searchData"
      :selectRowData="selectRowData"
      @closeDialog="closeDialog"
      @afterUpdate="afterUpdate"
    ></UpdatePage>

  </div>
</template>

<script>
    import Pagination from '@/components/Pagination.vue'
    import AddPage from '@/module/interactionCenter/page/cec/interface/add.vue'
    import UpdatePage from '@/module/interactionCenter/page/cec/interface/update.vue'
    import api from '@/module/interactionCenter/api/interface.js'

    export default {
        data() {
            return {
                addFormVisible: false,
                updateFormVisible: false,
                offVisible: false,
                onVisible: true,
                loading: false, // 是显示加载
                // 选择数据
                selectData: [],
                // 请求数据参数
                formInline: {
                    t: {
                        interfaceName: '',
                         startTime:'',
                         endTime:''
                    }
                },
                // 分页参数
                pageParam: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                },
                // 列表数据
                userData: [],
                // 表单查询条件
                searchData: {
                },

                // 选中列数据
                selectRowData: {},
              pickerOptions: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
                shortcuts: [{
                  text: '今天',
                  onClick(picker) {
                    picker.$emit('pick', new Date());
                  }
                }, {
                  text: '昨天',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                  }
                }, {
                  text: '一周前',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                  }
                }]
              }
            }
        },
        // 注册组件
        components: {
            AddPage,
            Pagination,
            UpdatePage
        },
        created() {
            this.search()
        },
        filters: {
        },
        watch: {},
        methods: {
            handleDelete(index, row) {
                if (!row) {
                    return
                }
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.deleteInterfaceById(row.id).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            // 获取数据方法
            getData(parameter) {
                this.loading = true
                api.getPage(JSON.stringify(parameter)).then((res) => {
                    this.userData = res.data.list
                    // 分页赋值
                    this.pageParam.currentPage = res.data.pageNum
                    this.pageParam.total = res.data.total

                    // 加载结束
                    this.loading = false
                }).catch(error => {
                    this.loading = false
                })
            }
            ,
            // 分页插件事件
            callFather() {
                let data = {
                    currentPage: this.pageParam.currentPage,
                    pageSize: this.pageParam.pageSize,
                    t: this.formInline.t
                }
                this.getData(data)
            }
            ,
            resetSearchForm() {
                this.formInline.t = {}
                this.search()
            },
            // 搜索事件
            search() {
                this.getData(this.formInline)
            }
            ,
            // 显示编辑界面
            handleEdit: function (index, row) {
                if (row !== undefined) {
                    this.selectRowData = row
                    this.updateFormVisible = true
                }
            }
            ,
            // 添加
            handleAdd: function () {
                this.addFormVisible = true
            }
            ,
            // 选择复选框事件
            selectChange(val) {
                this.selectData = val
            }
            ,
            // 更新成功之后的操作
            afterUpdate() {
                this.updateFormVisible = false
                this.callFather()
            }
            ,
            // 添加成功后操作
            afterAdd() {
                this.addFormVisible = false
                this.search()
            }
            ,
            // 关闭弹框
            closeDialog(type) {
                console.log('type:' + type)
                if (type === 'update') {
                    this.updateFormVisible = false
                } else if (type === 'add') {
                    this.addFormVisible = false
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/interactionCenter/page/cec/interface/list.vue